import { createAction, props } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { AppSettings } from 'src/app/modules/shared/model/appSettings.model';

export const loadAppSettings = createAction(
  '[AppSettings] Load AppSettings',
  props<AppSettings>()
);

export const loadAppSettingsSuccess = createAction(
  '[AppSettings] Load AppSettings Success',
  props<AppSettings>()
);

export const loadAppSettingsFailure = createAction(
  '[AppSettings] Load AppSettings Failure',
  props<{ error: any }>()
);

export const addAppSettings = createAction(
  '[AppSettings] Add AppSettings',
  props<AppSettings>()
);

export const addAppSettingsSuccess = createAction(
  '[AppSettings] Add AppSettings Success',
  props<AppSettings>()
);

export const addAppSettingsFailure = createAction(
  '[AppSettings] Add AppSettings Failure',
  props<{ error: any }>()
);

